import React, { useEffect } from 'react';
import { userService } from 'services/userService';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import MenuMobile from 'components/menu/menuMobile';
import Header from '../../components/header';
import Menu from '../../components/menu';

const HeaderContainer = () => {
  const dispatch = useDispatch();
  const { user, status } = useSelector((state) => state.user);

  useEffect(() => {
    userService(dispatch);
    if (status === 'error') {
      Cookies.remove('jwt_clubpremier');
    }
    if (status === 'success' && Cookies.get('jwt_clubpremier') === undefined && user !== []) {
      const inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000);
      Cookies.set('jwt_clubpremier', 'subastas', {
        expires: inTwentyMinutes,
      });
    }
  }, []);

  return (
    <div>
      <Header
        user={user}
        status={status} />
      <Menu />
      <MenuMobile />
    </div>
  );
};

export default HeaderContainer;
